import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../api";
const AdminPanel = () => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [htmlContent, setHtmlContent] = useState(""); // For fetching admin HTML page
  const [formData, setFormData] = useState({
    title: "",
    company: "",
    location: "",
    description: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login"); // Redirect to login if token is missing
    } else {
      fetchAdminPage(); // Fetch admin panel HTML content
      fetchJobs();
    }
  }, []);

  const fetchAdminPage = async () => {
    try {
      const response = await fetch("/admin-login");
      if (!response.ok) throw new Error("Failed to load admin page");
      const data = await response.text();
      setHtmlContent(data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchJobs = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/admin/jobs`, {
        headers: { Authorization: token },
      });
      if (!response.ok) throw new Error("Failed to fetch jobs");
      const data = await response.json();
      setJobs(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddJob = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/admin/jobs`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify(formData),
      });
      if (!response.ok) throw new Error("Failed to add job");
      fetchJobs();
      setFormData({ title: "", company: "", location: "", description: "" });
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteJob = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/admin/jobs/${id}`, {
        method: "DELETE",
        headers: { Authorization: token },
      });
      if (!response.ok) throw new Error("Failed to delete job");
      fetchJobs();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="p-5 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold text-center mb-5">Admin Panel</h1>
      
      {/* Display admin panel HTML from Flask */}
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} className="mb-5 p-4 bg-gray-100 rounded shadow" />

      <form onSubmit={handleAddJob} className="flex flex-col space-y-3 bg-gray-100 p-5 rounded-lg shadow-md">
        <input type="text" name="title" placeholder="Title" value={formData.title} onChange={handleInputChange} required className="p-2 border rounded" />
        <input type="text" name="company" placeholder="Company" value={formData.company} onChange={handleInputChange} required className="p-2 border rounded" />
        <input type="text" name="location" placeholder="Location" value={formData.location} onChange={handleInputChange} required className="p-2 border rounded" />
        <textarea name="description" placeholder="Description" value={formData.description} onChange={handleInputChange} required className="p-2 border rounded"></textarea>
        <button type="submit" className="p-2 bg-green-500 text-white rounded hover:bg-green-600">Add Job</button>
      </form>

      <ul className="mt-5 space-y-2">
        {jobs.map((job) => (
          <li key={job.id} className="border p-3 flex justify-between items-center bg-white rounded shadow">
            <span>{job.title} - {job.company}</span>
            <button onClick={() => handleDeleteJob(job.id)} className="bg-red-500 text-white p-1 rounded hover:bg-red-600">Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AdminPanel;
